<script setup>
import stateStore from "../../utils/store"
import { useI18n } from 'vue-i18n'
import { RouterLink } from "vue-router"
import { ref, onMounted } from 'vue'
import { useRoute } from "vue-router";
import { urlDoAdmin } from "@/services/sso.js";
import { listarPacotes } from "@/modules/documentacao/service.js";

const stateStoreInstance = stateStore;
const { t } = useI18n()
const loading = ref(false);
const route = useRoute();
const pacotes = ref([]);

const isActive = (item) => {
    if (!item) return false;
    return route.path.startsWith(item);
};

// O accounts e um satelite do admin: quem chega aqui veio de la e precisa
// conseguir voltar para as outras aplicacoes. Sem isto a unica saida da tela e
// encerrar a sessao.
//
// Link de verdade, e nao RouterLink: o admin e outra origem.
const linkDoAdmin = urlDoAdmin("/home");

onMounted(async () => {
    try {
        pacotes.value = await listarPacotes();
    } catch (err) {
        console.error("Nao foi possivel listar os pacotes no menu:", err);
    } finally {
        loading.value = true;
    }
})

</script>


<template>
    <div
        :class="[
            'sidebar-area bg-white box-shadow',
            { active: stateStoreInstance.open },
        ]"
        id="SidebarTheme"
    >
        <div class="logo bg-white">
            <RouterLink to="/users" class="d-flex align-items-center">
                <v-img class="logo-img" src="/images/static/logos/logo-icon.png" alt="logo" />
                <span class="fw-bold text-black position-relative">hLiberty</span>
            </RouterLink>
        </div>
        <div
            :class="['burger-menu', { active: stateStoreInstance.open }]"
            @click="stateStoreInstance.onChange"
        >
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>
        <div class="virtual-scroll">
            <div class="sidebar-inner">
                <div class="sidebar-menu pt-2" v-if="loading">
                    <span class="sub-title">Documentação</span>
                    <RouterLink
                        to="/documentacao"
                        class="sidebar-menu-link"
                        :class="{ 'router-link-active': route.path === '/documentacao' }"
                    >
                        <span class="material-symbols-outlined">home</span>
                        <span class="title">Visão geral</span>
                    </RouterLink>
                    <RouterLink
                        to="/documentacao/guias/sso"
                        class="sidebar-menu-link"
                        :class="{ 'router-link-active': route.path === '/documentacao/guias/sso' }"
                    >
                        <span class="material-symbols-outlined">login</span>
                        <span class="title">Guia: SSO pelo admin</span>
                    </RouterLink>
                    <RouterLink
                        to="/documentacao/guias/construcao"
                        class="sidebar-menu-link"
                        :class="{ 'router-link-active': route.path === '/documentacao/guias/construcao' }"
                    >
                        <span class="material-symbols-outlined">build</span>
                        <span class="title">Guia: Construção e publicação</span>
                    </RouterLink>

                    <span class="sub-title">Pacotes</span>
                    <RouterLink
                        v-for="p in pacotes"
                        :key="p.pacote"
                        :to="{ name: 'documentacao-pacote', params: { pacote: p.pacote } }"
                        class="sidebar-menu-link"
                        :class="{ 'router-link-active': isActive('/documentacao/pacotes/' + p.pacote) }"
                    >
                        <span class="material-symbols-outlined">description</span>
                        <span class="title">{{ p.titulo }}</span>
                    </RouterLink>
                    <p v-if="!pacotes.length" class="sidebar-sem-acesso">
                        Nenhum pacote documentado ainda.
                    </p>

                    <a v-if="linkDoAdmin" :href="linkDoAdmin" class="sidebar-menu-link">
                        <span class="material-symbols-outlined">apps</span>
                        <span class="title">{{ t("common.labels.backToAdmin") }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.sidebar-sem-acesso {
    padding: 12px 16px;
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--secondaryColor, #6b7280);
}

.sidebar-area {
    transition: var(--transition);
    border-radius: 0 10px 10px 0;
    overflow: hidden;
    position: fixed;
    height: 100vh;
    width: 260px;
    z-index: 222;
    left: 0;
    top: 0;

    .virtual-scroll {
        height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
            -webkit-appearance: none;
        }
        &::-webkit-scrollbar:vertical {
            width: 5px;
        }
        &::-webkit-scrollbar:horizontal {
            height: 5px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 50px;
            background-color: rgba(0, 0, 0, 0.2);
        }
        &::-webkit-scrollbar-track {
            background: var(--whiteColor);
        }
    }

    .logo-img {
        width: 50px!important;
    }

    .logo {
        border-bottom: 1px solid var(--borderColor);
        padding: 15px 25px 19px;
        position: absolute;
        z-index: 2;
        right: 0;
        left: 0;
        top: 0;
        a {
            transition: unset;
            span {
                margin-left: 8px;
                font-size: 24px;
                top: 1px;
            }
        }
    }
    .burger-menu {
        top: 25px;
        z-index: 3;
        opacity: 0;
        right: 15px;
        cursor: pointer;
        position: absolute;
        visibility: hidden;
        transition: var(--transition);

        span {
            height: 1px;
            width: 25px;
            margin: 6px 0;
            display: block;
            background: var(--blackColor);
            transition: var(--transition);
        }
        &.active {
            opacity: 1;
            visibility: visible;

            span {
                &.top-bar {
                    transform: rotate(45deg);
                    transform-origin: 10% 10%;
                }
                &.middle-bar {
                    opacity: 0;
                }
                &.bottom-bar {
                    transform: rotate(-45deg);
                    transform-origin: 10% 90%;
                    margin-top: 5px;
                }
            }
        }
    }
    .sidebar-inner {
        padding: 90px 10px 20px 10px;
        .sidebar-menu {
            .sub-title {
                display: block;
                font-size: 12px;
                margin-bottom: 10px;
                text-transform: uppercase;
                color: #8695aa;
                &:not(:first-child) {
                    margin-top: 10px;
                }
            }
        }
    }
    .sidebar-menu-link {
        transition: var(--transition);
        color: var(--blackColor);
        margin-bottom: 5px;
        position: relative;
        border-radius: 7px;
        display: block;
        padding: 11.5px 30px 11.5px 40px;
        font-size: var(--fontSize);
        font-weight: 500;
        i,
        .material-symbols-outlined {
            transition: var(--transition);
            transform: translateY(-50%);
            color: var(--bodyColor);
            position: absolute;
            font-size: 22px;
            line-height: 1;
            left: 12px;
            top: 50%;
        }
        &:hover,
        &.router-link-active {
            color: var(--primaryColor);
            background-color: #f6f7f9;
            i,
            .material-symbols-outlined {
                color: var(--primaryColor);
            }
        }
    }
    &.active {
        width: 60px;

        .logo {
            padding: {
                left: 12px;
                right: 12px;
            }
            a {
                span {
                    display: none;
                }
            }
        }
        .sidebar-inner {
            padding: {
                top: 80px;
                left: 12px;
                right: 12px;
            }
        }
        .sidebar-menu {
            .sub-title {
                display: none;
            }
        }
        .sidebar-menu-link {
            padding: 0;
            width: 36px;
            height: 36px;

            i,
            .material-symbols-outlined {
                left: 4px;
            }
            .title {
                display: none;
            }
        }
        .burger-menu {
            opacity: 0;
            visibility: hidden;
        }
        &:hover {
            width: 260px;

            .logo {
                padding: {
                    left: 15px;
                    right: 15px;
                }
                a {
                    span {
                        display: inline-block;
                    }
                }
            }
            .burger-menu {
                opacity: 1;
                visibility: visible;
            }
            .sidebar-inner {
                padding: {
                    top: 100px;
                    left: 15px;
                    right: 15px;
                }
            }
            .sidebar-menu {
                .sub-title {
                    display: block;
                }
            }
            .sidebar-menu-link {
                width: auto;
                height: auto;
                padding: {
                    bottom: 14px;
                    right: 60px;
                    left: 37px;
                    top: 14px;
                }
                i {
                    left: 15px;
                    right: auto;
                    text-align: unset;
                }
                .title {
                    display: block;
                }
            }
        }
    }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .sidebar-area {
        width: 250px;
        left: -100%;

        .logo {
            padding: {
                top: 15px;
                bottom: 15px;
            }
            a {
                span {
                    margin-left: 15px;
                }
            }
        }
        .sidebar-menu {
            .sub-title {
                font-size: 13px;
                padding-top: 16px!important;
            }
        }
        .burger-menu {
            top: 25px;
            right: 12px;
        }
        .sidebar-inner {
            padding-top: 75px;
        }
        .sidebar-menu-link {
            font-size: 13px;
            padding: 8px 25px 8px 37px;
            i {
                font-size: 14px;
                left: 12px;
            }
        }
        &.active {
            width: 250px;
            left: 0;

            .logo {
                padding: {
                    left: 12px;
                    right: 12px;
                }
                a {
                    span {
                        display: inline-block;
                    }
                }
            }
            .burger-menu {
                opacity: 1;
                visibility: visible;
            }
            .sidebar-inner {
                padding: {
                    top: 75px;
                    left: 12px;
                    right: 12px;
                }
            }
            .sidebar-menu {
                .sub-title {
                    display: block;
                }
            }
            .sidebar-menu-link {
                width: auto;
                height: auto;
                padding: {
                    bottom: 13px;
                    right: 50px;
                    left: 34px;
                    top: 13px;
                }
                i {
                    left: 12px;
                    right: auto;
                    text-align: unset;
                }
                .title {
                    display: block;
                }
            }
            &:hover {
                width: 250px;

                .logo {
                    padding: {
                        left: 12px;
                        right: 12px;
                    }
                    a {
                        span {
                            display: inline-block;
                        }
                    }
                }
                .burger-menu {
                    opacity: 1;
                    visibility: visible;
                }
                .sidebar-inner {
                    padding: {
                        top: 75px;
                        left: 12px;
                        right: 12px;
                    }
                }
                .sidebar-menu {
                    .sub-title {
                        display: block;
                    }
                }
                .sidebar-menu-link {
                    width: auto;
                    height: auto;
                    padding: {
                        bottom: 13px;
                        right: 50px;
                        left: 34px;
                        top: 13px;
                    }
                    i {
                        left: 12px;
                        right: auto;
                        text-align: unset;
                    }
                    .title {
                        display: block;
                    }
                }
            }
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .sidebar-area {
        left: -100%;

        .sidebar-inner {
            padding-top: 85px;
        }
        &.active {
            width: 260px;
            left: 0;

            .logo {
                padding: {
                    left: 15px;
                    right: 15px;
                }
                a {
                    span {
                        display: inline-block;
                    }
                }
            }
            .burger-menu {
                opacity: 1;
                visibility: visible;
            }
            .sidebar-inner {
                padding: {
                    top: 80px;
                    left: 15px;
                    right: 15px;
                }
            }
            .sidebar-menu {
                .sub-title {
                    display: block;
                }
            }
            .sidebar-menu-link {
                width: auto;
                height: auto;
                padding: {
                    bottom: 14px;
                    right: 60px;
                    left: 37px;
                    top: 14px;
                }
                i {
                    left: 15px;
                    right: auto;
                    text-align: unset;
                }
                .title {
                    display: block;
                }
            }
            &:hover {
                width: 260px;

                .sidebar-inner {
                    padding-top: 80px;
                }
            }
        }
    }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .sidebar-area {
        left: -100%;

        &.active {
            width: 260px;
            left: 0;

            .logo {
                padding: {
                    left: 15px;
                    right: 15px;
                }
                a {
                    span {
                        display: inline-block;
                    }
                }
            }
            .burger-menu {
                opacity: 1;
                visibility: visible;
            }
            .sidebar-inner {
                padding: {
                    top: 80px;
                    left: 15px;
                    right: 15px;
                }
            }
            .sidebar-menu {
                .sub-title {
                    display: block;
                }
            }
            .sidebar-menu-link {
                width: auto;
                height: auto;
                padding: {
                    bottom: 14px;
                    right: 60px;
                    left: 37px;
                    top: 14px;
                }
                i {
                    left: 15px;
                    right: auto;
                    text-align: unset;
                }
                .title {
                    display: block;
                }
            }
            &:hover {
                width: 260px;

                .sidebar-inner {
                    padding-top: 80px;
                }
            }
        }
    }
}
</style>
